<div class="emotion-quadrant" fxLayout="column" fxLayoutAlign="space-between stretch" fxFill>
  <form [formGroup]="emotionQuadrantForm" fxLayout="column" fxLayoutAlign="space-between stretch" fxFill>
    <div fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="20px">
      <dashboard-module-item-core
        [dialogData]="dialogData"
        formControlName="moduleItemCore"
      ></dashboard-module-item-core>
      <div fxLayout="column" *ngIf="translations?.controls.length">
        <div formArrayName="translations" *ngFor="let item of translations?.controls; let i = index">
          <div
            [formGroupName]="i"
            fxFlex="100"
            *ngIf="item.get('identifier')?.value === MODULE_ITEM_EMOTION_IMAGE_IDENTIFIER"
          >
            <dashboard-image-upload
              formControlName="translation"
              [uuid]="imageUploadUuids[i]"
              [label]="'Quadrant image (' + getItemLanguageLabel(item.get('language')?.value) + ')'"
              [isEdit]="isEdit"
              [isImageToEdit]="!!quadrantImgPathArray[i]"
              [imgPath]="quadrantImgPathArray[i]"
              [keyForUpload]="keyForUpload"
              [idsForUpload]="idsForUpload"
            >
            </dashboard-image-upload>
          </div>
        </div>
      </div>
    </div>
    <div
      class="emotion-quadrant__actions"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL)"
    >
      <button mat-raised-button color="primary" (click)="closeModuleItemDialog()">
        {{ 'Cancel' | uppercase }}
      </button>
      <button mat-raised-button color="primary" (click)="saveModuleItem()">
        {{ 'Save' | uppercase }}
      </button>
    </div>
  </form>
</div>
